import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=8049b7c8&"
import script from "./Radio.vue?vue&type=script&lang=js&"
export * from "./Radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports